/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';

import Money from '../../../common/money';
import withToggle from '../../../common/hoc/withToggle';
import CollectedByPaymentModal from './CollectedByPaymentModal';

const buildItems = (items) => [
  {
    title: t('reports:payment_methods.pos_card'),
    amount: items.totalPos,
  },
  {
    title: t('reports:payment_methods.squire_card'),
    amount: items.totalSquire,
  },
  {
    title: t('reports:payment_methods.cash'),
    amount: items.totalCash,
  },
  {
    title: t('reports:payment_methods.gift_cards'),
    amount: items.totalGiftCard,
  },
];

const CollectedByPaymentList = (props) => {
  const {
    items,
    title,
    shouldShowModalOn,
    shouldShowModalOff,
    shouldShowModalIsOn,
    includeModalColumns,
    includeModalRows,
  } = props;

  const data = buildItems(items);

  return (
    <div className="c-report-panel o-flexbox o-flexbox--column">
      <div className="c-heading--small u-co-primary u-type--bold u-type--uppercase u-mb">
        {title || t('reports:payment_methods.collected_by_payment')}
      </div>
      <ul className="list-bare u-flex-1">
        {data.map(item => (
          <li className="u-mb" key={item.title}>
            <div className="o-flexbox">
              {item.title}
              <Money automationId={`text:paymentMethod:${item.title}:amount`} cents={item.amount} />
            </div>
          </li>
        ))}
      </ul>
      <div
        className="c-report-label u-fontsize-medium u-type--underline u-cursor-pointer u-co-primary u-text-right"
        onClick={shouldShowModalOn}
      >
        {t('reports:payment_methods.details')}
      </div>
      <CollectedByPaymentModal
        items={items}
        close={shouldShowModalOff}
        includeColumns={includeModalColumns}
        includeRows={includeModalRows}
        display-if={shouldShowModalIsOn}
      />
    </div>
  );
};

CollectedByPaymentList.propTypes = {
  items: PropTypes.object,
  title: PropTypes.string,
  shouldShowModalOn: PropTypes.func.isRequired,
  shouldShowModalOff: PropTypes.func.isRequired,
  shouldShowModalIsOn: PropTypes.bool.isRequired,
  includeModalColumns: PropTypes.arrayOf(PropTypes.string), // eslint-disable-line react/require-default-props
  includeModalRows: PropTypes.arrayOf(PropTypes.string), // eslint-disable-line react/require-default-props
};

CollectedByPaymentList.defaultProps = {
  items: {},
  title: null,
};

export default withToggle('shouldShowModal', false)(CollectedByPaymentList);
